import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG} from '../common/redux/constantes';
import SelectDeliverable from './SelectDeliverable';
import SelectControlAccount from './SelectControlAccount';
import DownloadCsv from "../common/DownloadCsv"
export default class GenericCost extends Component {
  static propTypes = {

  };


  state ={
    costs:[],
    deliverableSelected:-1, 
    tableData:{}
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    //bindings
    this.changeDeliverableSelected = this.changeDeliverableSelected.bind(this);
    this.setCostInfo= this.setCostInfo.bind(this)
  }

  changeDeliverableSelected(deliverable_id)
  {
    this.setState({deliverableSelected:deliverable_id});
    this.refreshTable();
  }  


  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }
  setCostInfo=(info)=>{
   let value={ data:JSON.parse(JSON.stringify(info)), 
            headers:[
            {label:"Type", key:"type"},
            {label:"Total Cost", key:"total_cost"}
            ],
            tableName:"CostsSummary", 
            lookupTable:['Labor','Equipment','Material','Other', 'SubContract','Total'],
            type:1
          }
    this.setState({
      tableData:value
    })
  }
  render() {
    let actionButtons = [
      {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
      },
      {
        icon: 'save',
        tooltip: 'Download Data',
        isFreeAction: true,
        onClick: () => 
        {
          this.childref.downloadData()
        }
      }
    ];
    return (
      <div className="summary-generic-cost">
          {this.props.project> 0?
            <SelectControlAccount  
              project={this.props.project}
              changeDeliverable={this.changeDeliverableSelected}
              />
            :
            <SelectDeliverable  
              ca_name={this.props.ca_name} 
              project={this.props.project} 
              ca={this.props.ca} 
              changeDeliverable={this.changeDeliverableSelected}/>
          }
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: rowData => ({
              backgroundColor:  rowData.result ===1? '#e7e8ec' :(rowData.cost>0) ? '#f0f1f3' : '#ffffff'
            })
          }}
          title="Summary"
          columns={[
            { 
              title: 'Type', 
              field: 'type', 
              lookup:{
                  1:'Labor',
                  2:'Equipment', 
                  3:'Material',
                  4:'Other', 
                  5:'SubContract',
                  6:'Total'
                },
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
            },
            { 
              title: 'Total Cost', 
              field: 'total_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
        parentChildData={(row, rows) => {
          if(row.cost>0)
          {
            return rows.find(a=> a.cost_catalog === row.cost_catalog);
          }
        }}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/costs/getSummaryByControlAccount/'+ this.props.ca + '/' + this.state.deliverableSelected;
            if(this.props.project > 0)
            {
              url = SERVER_PATH + '/costs/getSummaryByProject/'+ this.props.project + '/' + this.state.deliverableSelected; //Este es control account
            }
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                {
                  formatter = new Intl.NumberFormat('gt-GT', {
                    minimumFractionDigits: 2,
                  });
                }
                let total_cost = 0;
                let cost_types = [false,false,false,false,false];
                result.costs = result.costs.map(o => {
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    total_cost += o.total_cost;
                    o.total_cost = formatter.format(o.total_cost);
                  }
                  cost_types[o.type - 1] = true;
                  return o;
                });

                for (let i=0; i< cost_types.length; i++)
                {
                  if(!cost_types[i])
                  {
                    result.costs.push({"type":i+1, "total_cost":0});
                  }
                }
                result.costs = result.costs.sort((a, b) => (a.type > b.type));
                let temporal = result.costs[3];
                result.costs[3] = result.costs[4];
                result.costs[4] = temporal;

                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                {
                  total_cost = formatter.format(total_cost);
                  result.costs.push({"type":6, "total_cost":total_cost, "result":1});
                }
                
                this.setCostInfo(result.costs)
                resolve({
                  data: result.costs,
                  page: 0,
                  totalCount: result.costs.length,
                })
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }
          actions={actionButtons}
        />
        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/summary/GeneralSummary.js